/* Extend the existing React header without rebuilding its shared storefront bundle. */
(() => {
  'use strict';
  if (window.voltNavigationReady) return;
  window.voltNavigationReady = true;
  const config = document.getElementById('volt-navigation-config');
  if (!config) return;
  let settings;
  try { settings = JSON.parse(config.textContent); } catch { return; }
  const upgraded = new WeakSet();
  const footerUpgraded = new WeakSet();
  const previews = new Map();
  function updatePreviews() {
    for (const [node, unmount] of previews) {
      if (!node.isConnected || !node.closest('details')?.open) { unmount(); previews.delete(node); }
    }
    if (!window.VoltProductPreview) return;
    document.querySelectorAll('.volt-shop-menu[open] .volt-shop-live').forEach(node => {
      if (previews.has(node)) return;
      previews.set(node, window.VoltProductPreview.mount(node, node.dataset.model, 1));
    });
  }
  window.addEventListener('volt-product-preview-ready', updatePreviews);
  const shopRequested = new URLSearchParams(window.location.search).get('shop') === '1';
  let shopOpened = false;
  let pendingShop = false;
  const chevron = () => {
    const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('width', '16');
    icon.setAttribute('height', '16');
    icon.setAttribute('aria-hidden', 'true');
    icon.setAttribute('fill', 'none');
    icon.setAttribute('stroke', 'currentColor');
    icon.setAttribute('stroke-width', '1.5');
    icon.setAttribute('stroke-linecap', 'round');
    icon.setAttribute('stroke-linejoin', 'round');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'm6 9 6 6 6-6');
    icon.append(path);
    return icon;
  };
  const link = (item) => {
    const node = document.createElement('a');
    node.href = item.href;
    node.textContent = item.label;
    const destination = new URL(node.href);
    if (destination.pathname === window.location.pathname) {
      node.setAttribute('aria-current', 'page');
    }
    return node;
  };
  function disclosure(label, items, mobile, shop) {
    const details = document.createElement('details');
    details.className = 'volt-support-menu' + (mobile ? ' volt-support-menu-mobile' : '') + (shop ? ' volt-shop-menu' : '');
    const summary = document.createElement('summary');
    summary.append(label, chevron());
    const links = document.createElement('div');
    links.className = 'volt-support-links';
    items.forEach(item => {
      const entry = link(item);
      if (shop) {
        const model = item.label.startsWith('X5') ? 'X5' : 'X3';
        entry.className = 'volt-shop-choice';
        entry.setAttribute('aria-label', item.label);
        const heading = document.createElement('span');
        heading.className = 'volt-shop-option-title';
        const name = document.createElement('strong');
        name.textContent = model;
        const version = document.createElement('span');
        version.className = 'volt-shop-version';
        version.textContent = model === 'X3' ? 'V1.2' : 'V1.1';
        heading.append(name, version);
        const photo = document.createElement('span');
        photo.className = 'volt-shop-scene';
        photo.setAttribute('aria-hidden', 'true');
        const live = document.createElement('span');
        live.className = 'volt-shop-live';
        live.dataset.model = model;
        const fallback = document.createElement('img');
        fallback.className = 'volt-shop-option-image';
        fallback.src = item.image;
        fallback.alt = '';
        fallback.width = 240;
        fallback.height = 240;
        photo.append(live, fallback);
        entry.replaceChildren(heading, photo);
      }
      links.append(entry);
    });
    details.append(summary, links);
    if (shop) details.addEventListener('toggle', updatePreviews);
    let hoverOpened = false;
    let closeTimer;
    const cancelClose = () => window.clearTimeout(closeTimer);
    const open = () => {
      cancelClose();
      details.parentElement?.querySelectorAll('.volt-support-menu[open]').forEach(other => {
        if (other !== details) other.open = false;
      });
      details.open = true;
    };
    summary.addEventListener('click', event => {
      event.preventDefault();
      cancelClose();
      if (details.open && !hoverOpened) details.open = false; else open();
      hoverOpened = false;
    });
    if (shop && !mobile) {
      details.addEventListener('pointerenter', event => {
        cancelClose();
        if (event.pointerType !== 'mouse' || !window.matchMedia('(min-width: 980px) and (hover: hover) and (pointer: fine)').matches) return;
        if (!details.open) { open(); hoverOpened = true; }
      });
      details.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        cancelClose();
        closeTimer = window.setTimeout(() => {
          if (details.querySelector(':focus-visible')) return;
          details.open = false;
          hoverOpened = false;
        }, 180);
      });
      details.addEventListener('toggle', () => {
        if (!details.open) { cancelClose(); hoverOpened = false; }
      });
    }
    details.addEventListener('keydown', event => {
      const entries = Array.from(links.querySelectorAll('a'));
      const navigationKeys = shop ? ['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft', 'Home', 'End'] : ['ArrowDown', 'ArrowUp', 'Home', 'End'];
      if (event.key === 'Escape' && details.open) {
        event.preventDefault();
        event.stopPropagation();
        cancelClose();
        hoverOpened = false;
        details.open = false;
        summary.focus();
      } else if (event.target === summary && ['ArrowDown', 'ArrowUp'].includes(event.key)) {
        event.preventDefault();
        hoverOpened = false;
        open();
        entries[event.key === 'ArrowDown' ? 0 : entries.length - 1]?.focus();
      } else if (entries.includes(event.target) && navigationKeys.includes(event.key)) {
        event.preventDefault();
        cancelClose();
        hoverOpened = false;
        const index = entries.indexOf(event.target);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? entries.length - 1 :
          (index + (['ArrowDown', 'ArrowRight'].includes(event.key) ? 1 : -1) + entries.length) % entries.length;
        entries[next].focus();
      }
    });
    details.addEventListener('focusout', event => {
      if (event.relatedTarget instanceof Node && !details.contains(event.relatedTarget)) details.open = false;
    });
    return details;
  }
  function upgrade(container, mobile) {
    if (upgraded.has(container)) return;
    const originals = Array.from(container.children).filter(node => node.tagName === 'A');
    const warranty = originals.find(node => /\/activate-?warranty\/?$/.test(new URL(node.href).pathname));
    const contact = originals.find(node => new URL(node.href).pathname.endsWith('/contact'));
    const shop = originals.find(node => /\/(?:pages\/)?shop\/?$/.test(new URL(node.href).pathname));
    if (!warranty || !contact || !shop || !settings.shop?.items?.length) return;
    // Keep React-owned nodes in place so cart updates and menu teardown remain safe.
    [warranty, contact, shop].forEach(node => {
      node.classList.add('volt-navigation-replaced');
      node.setAttribute('aria-hidden', 'true');
      node.tabIndex = -1;
    });
    const tracking = link(settings.tracking);
    tracking.className = 'volt-track-order-link';
    if (mobile) tracking.append(chevron());
    const support = disclosure(settings.support, settings.items, mobile, false);
    container.insertBefore(disclosure(settings.shop.label, settings.shop.items, mobile, true), shop);
    container.insertBefore(tracking, warranty);
    container.insertBefore(support, contact);
    upgraded.add(container);
  }
  function update() {
    updatePreviews();
    document.querySelectorAll('.volt-desktop-links').forEach(node => upgrade(node, false));
    document.querySelectorAll('.volt-menu').forEach(node => upgrade(node, true));
    document.querySelectorAll('.vf-links').forEach(container => {
      if (footerUpgraded.has(container)) return;
      const original = Array.from(container.children).find(node => node.tagName === 'A' && /\/(?:pages\/)?shop\/?$/.test(new URL(node.href).pathname));
      if (!original || !settings.shop?.items?.length) return;
      original.classList.add('volt-navigation-replaced');
      original.setAttribute('aria-hidden', 'true');
      original.tabIndex = -1;
      settings.shop.items.forEach(item => container.insertBefore(link(item), original));
      footerUpgraded.add(container);
    });
    if (pendingShop || (shopRequested && !shopOpened)) openShop();
  }
  function openShop() {
    pendingShop = true;
    const mobile = !window.matchMedia('(min-width: 980px)').matches;
    const toggle = document.querySelector('.volt-mobile-menu-toggle');
    if (mobile && toggle?.getAttribute('aria-expanded') === 'false') {
      toggle.click();
      return;
    }
    const menu = document.querySelector(mobile ? '.volt-menu .volt-shop-menu' : '.volt-desktop-links .volt-shop-menu');
    if (!menu) return;
    menu.open = true;
    menu.querySelector('summary')?.focus({ preventScroll: true });
    shopOpened = true;
    pendingShop = false;
    if (shopRequested) {
      const url = new URL(window.location.href);
      url.searchParams.delete('shop');
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    }
  }
  document.addEventListener('click', event => {
    const anchor = event.target instanceof Element ? event.target.closest('a') : null;
    if (!anchor || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (new URL(anchor.href).origin === window.location.origin && /\/(?:pages\/)?shop\/?$/.test(new URL(anchor.href).pathname)) {
      event.preventDefault();
      openShop();
    }
  });
  document.addEventListener('pointerdown', event => {
    document.querySelectorAll('.volt-support-menu[open]').forEach(node => {
      if (!node.contains(event.target)) node.open = false;
    });
  });
  // React creates the mobile menu on demand and may remount the theme section.
  const observer = new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1))) update();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  const breakpoint = window.matchMedia('(min-width: 980px)');
  breakpoint.addEventListener('change', () => {
    document.querySelectorAll('.volt-support-menu[open]').forEach(node => {
      const containedFocus = node.contains(document.activeElement);
      node.open = false;
      if (containedFocus) {
        const target = breakpoint.matches ? '.volt-desktop-links .volt-shop-menu > summary' : '.volt-mobile-menu-toggle';
        document.querySelector(target)?.focus();
      }
    });
  });
  update();
})();
